<template>
    <section id="contact" class="contact-section" aria-label="Contato">
        <div class="contact-content">
            <div class="contact-cta">
                <div>
                    <span class="section-tag">Contato</span>
                    <h2 class="section-title-modern">
                        Conte onde sua operação está travando.
                    </h2>
                    <p class="section-description">
                        Ajudamos a transformar processos manuais, sistemas desconectados e rotinas críticas em soluções
                        digitais confiáveis, seja em operações jurídicas, administrativas, financeiras ou de outros
                        segmentos.
                    </p>
                </div>

                <div class="contact-panel">
                    <form class="contact-form" @submit.prevent="openEmailClient">
                        <div class="form-row">
                            <label>
                                <span>Nome</span>
                                <input v-model="form.name" type="text" autocomplete="name" required />
                            </label>
                            <label>
                                <span>E-mail</span>
                                <input v-model="form.email" type="email" autocomplete="email" required />
                            </label>
                        </div>
                        <div class="form-row">
                            <label>
                                <span>Empresa</span>
                                <input v-model="form.company" type="text" autocomplete="organization" />
                            </label>
                            <label>
                                <span>Telefone</span>
                                <input v-model="form.phone" type="tel" autocomplete="tel" />
                            </label>
                        </div>
                        <label>
                            <span>Como podemos ajudar?</span>
                            <textarea v-model="form.message" rows="5" required></textarea>
                        </label>
                        <button class="contact-submit" type="submit">
                            Abrir e-mail
                            <v-icon size="18" color="#ffffff">mdi-arrow-right</v-icon>
                        </button>
                    </form>

                    <div class="contact-list">
                        <div class="contact-card-modern">
                            <div class="contact-card-icon-wrap" aria-hidden="true">
                                <v-icon size="22" color="#111111">mdi-email-outline</v-icon>
                            </div>
                            <div class="contact-card-info">
                                <span class="contact-card-label">E-mail</span>
                                <a
                                    class="contact-card-value"
                                    href="mailto:contato@mazzitech.com.br"
                                    aria-label="Enviar email para contato@mazzitech.com.br"
                                >
                                    contato@mazzitech.com.br
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <footer class="footer-bar">
                <div class="footer-line" aria-hidden="true"></div>
                <div class="footer-content-row">
                    <span class="footer-copy">© {{ currentYear }} MAZZITECH. Todos os direitos reservados.</span>
                </div>
            </footer>
        </div>
    </section>
</template>

<script>
export default {
    data() {
        return {
            form: {
                name: "",
                email: "",
                company: "",
                phone: "",
                message: "",
            },
        };
    },
    computed: {
        currentYear() {
            return new Date().getFullYear();
        },
    },
    methods: {
        openEmailClient() {
            const to = "contato@mazzitech.com.br";
            const subject = `Contato pelo site - ${this.form.name}`;
            const body = [
                `Nome: ${this.form.name}`,
                `E-mail: ${this.form.email}`,
                `Empresa: ${this.form.company || "Não informado"}`,
                `Telefone: ${this.form.phone || "Não informado"}`,
                "",
                "Mensagem:",
                this.form.message,
            ].join("\n");

            window.location.href = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        },
    },
};
</script>

<style lang="scss">
.contact-section {
    position: relative;
    background: #111111;
    padding: 112px 0 54px;
    overflow: hidden;
}

.contact-content {
    width: 75%;
    margin: 0 auto;
}

.contact-cta {
    display: grid;
    grid-template-columns: minmax(0, 1.1fr) minmax(320px, 0.9fr);
    gap: 64px;
    align-items: start;
}

.contact-section .section-tag {
    color: #bcbcb6;
}

.contact-section .section-title-modern {
    color: #ffffff;
}

.contact-section .section-description {
    color: rgba(255, 255, 255, 0.68);
    margin-left: 0;
}

.contact-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 14px;
}

.contact-panel {
    background: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 4px;
    padding: 28px;
}

.contact-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-row {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
}

.contact-form label {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.contact-form label span {
    color: #4f4f4a;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
}

.contact-form input,
.contact-form textarea {
    width: 100%;
    border: 1px solid #d9d9d3;
    border-radius: 4px;
    background: #f7f7f5;
    color: #111111;
    font-family: "Plus Jakarta Sans", sans-serif !important;
    font-size: 15px;
    line-height: 1.45;
    outline: none;
    transition: border-color 0.2s ease, background 0.2s ease;
}

.contact-form input {
    min-height: 46px;
    padding: 0 14px;
}

.contact-form textarea {
    resize: vertical;
    min-height: 128px;
    padding: 13px 14px;
}

.contact-form input:focus,
.contact-form textarea:focus {
    background: #ffffff;
    border-color: #0f4efb;
}

.contact-submit {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    min-height: 48px;
    margin-top: 2px;
    padding: 13px 24px;
    border: 1px solid #0f4efb;
    border-radius: 999px;
    background: #0f4efb;
    color: #ffffff !important;
    cursor: pointer;
    font-family: "Plus Jakarta Sans", sans-serif !important;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    transition: background 0.25s ease, border-color 0.25s ease;
}

.contact-submit:hover {
    background: #0b3fd3;
    border-color: #0b3fd3;
}

.contact-card-modern {
    display: flex;
    align-items: center;
    gap: 14px;
    height: 100%;
    padding: 18px 0 0;
    background: transparent;
    border-top: 1px solid #e2e2dc;
    border-radius: 0;
}

.contact-card-icon-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    min-width: 42px;
    border-radius: 4px;
    background: #f4f4f1;
    border: 1px solid #e2e2dc;
}

.contact-card-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.contact-card-label {
    color: #6d6d67;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.14em;
    text-transform: uppercase;
}

.contact-card-value {
    color: #111111 !important;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.45;
    text-decoration: none !important;
}

.footer-bar {
    margin-top: 90px;
}

.footer-line {
    height: 1px;
    background: rgba(255, 255, 255, 0.16);
    margin-bottom: 28px;
}

.footer-content-row {
    display: flex;
    justify-content: center;
    align-items: center;
}

.footer-copy {
    color: rgba(255, 255, 255, 0.52);
    font-size: 12px;
    letter-spacing: 0.05em;
}

@media (max-width: 960px) {
    .contact-content {
        width: 90%;
    }

    .contact-cta {
        grid-template-columns: 1fr;
        gap: 34px;
    }
}

@media (max-width: 560px) {
    .contact-panel {
        padding: 22px;
    }

    .form-row {
        grid-template-columns: 1fr;
    }

    .contact-submit {
        width: 100%;
    }
}
</style>
